<template>
  <div class="year-selector">
    <div class="mb-50 d-flex">
      <b-form-select v-model="year" class="w-100" :options="yearOptions" @change="onYearChanged" />
    </div>
    <div class="d-flex">
      <flat-pickr v-model="reportDatesRangeInput" class="form-control dates-range" :config="rangepickerConfig"
        placeholder="Dates d'entrada" @on-change="onDatesRangeChanged" />
    </div>
  </div>
</template>

<script>
import { BFormSelect } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { Catalan } from "flatpickr/dist/l10n/cat.js";
import { formatDateObjectToDatabaseDate } from "@/utils/formatters";

export default {
  components: {
    BFormSelect,
    flatPickr,
  },
  props: {
    value: {
      type: Object,
      default: () => ({ from: null, to: null }),
    },
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
    trimesters: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      year: new Date().getFullYear(),
      reportDatesRangeInput: null,
      reportDatesRange: {
        from: null,
        to: null,
      },
      rangepickerConfig: {
        mode: "range",
        locale: Catalan,
        altFormat: "d/m/Y",
        altInput: true,
      },
    };
  },
  computed: {
    yearOptions() {
      const options = [];
      const currentYear = new Date().getFullYear();
      for (let index = 0; index < 5; index++) {
        const iterationYear = currentYear - index;
        options.push({
          value: iterationYear,
          text: `${iterationYear}`,
        });
      }
      return options;
    },
  },
  created() {
    this.initSelectedDatesRange(this.year);
  },
  methods: {
    initSelectedDatesRange() {
      this.year = new Date().getFullYear();
      this.reportDatesRangeInput = `${this.year}-01-01 to ${this.year}-12-31`;
      this.reportDatesRange.from = formatDateObjectToDatabaseDate(
        new Date(this.year, 0, 1)
      );
      this.reportDatesRange.to = formatDateObjectToDatabaseDate(
        new Date(this.year, 11, 31)
      );
      this.$emit("input", this.reportDatesRange);
    },
    onDatesRangeChanged(selectedDates) {
      if (selectedDates?.length !== 2) return;
      this.reportDatesRange.from = formatDateObjectToDatabaseDate(
        selectedDates[0]
      );
      this.reportDatesRange.to = formatDateObjectToDatabaseDate(
        selectedDates[1]
      );
      this.$emit("input", this.reportDatesRange);
    },
    onYearChanged(year) {
      if (!year) return;
      this.reportDatesRangeInput = `${year}-01-01 to ${year}-12-31`;
    },
  },
};
</script>

<style lang="scss">
.year-selector {
  .dates-range {
    min-width: 200px;
  }
}
</style>
